module.exports = __webpack_public_path__ + "d6da70bcdefee77154dd0493cd6f5290.png";